import { IBettingSystem, ISerializableBetCommand } from './interfaces';

export class PlaceBetCommand implements ISerializableBetCommand {
    private bettingSystem: IBettingSystem;
    private betId: number;
    private chipSize: number;

    constructor(bettingSystem: IBettingSystem, betId: number, chipSize: number) {
        this.bettingSystem = bettingSystem;
        this.betId = betId;
        this.chipSize = chipSize;
    }

    execute(): void {
        this.bettingSystem.addBet(this.betId, this.chipSize);
        console.log(`Placed bet of ${this.chipSize} on game ${this.betId}`);
    }

    undo(): void {
        this.bettingSystem.removeLastBet(this.betId);
        console.log(`Undid bet of ${this.chipSize} on game ${this.betId}`);
    }

    serialize(): object {
        return {
            type: 'PlaceBetCommand',
            betId: this.betId,
            chipSize: this.chipSize
        };
    }

    static deserialize(bettingSystem: IBettingSystem, data: object): PlaceBetCommand {
        return new PlaceBetCommand(bettingSystem, data['betId'], data['chipSize']);
    }
}

export class BetLeftCommand implements ISerializableBetCommand {
    private bettingSystem: IBettingSystem;
    private chipSize: number;

    constructor(bettingSystem: IBettingSystem, chipSize: number) {
        this.bettingSystem = bettingSystem;
        this.chipSize = chipSize;
    }

    execute(): void {
        for (let i = 0; i < 4; i++) {
            this.bettingSystem.addBet(i, this.chipSize);
        }
        console.log(`Placed bet of ${this.chipSize} on games 0-3`);
    }

    undo(): void {
        for (let i = 0; i < 4; i++) {
            this.bettingSystem.removeLastBet(i);
        }
        console.log(`Undid bet of ${this.chipSize} on games 0-3`);
    }

    serialize(): object {
        return {
            type: 'BetLeftCommand',
            chipSize: this.chipSize
        };
    }

    static deserialize(bettingSystem: IBettingSystem, data: object): BetLeftCommand {
        return new BetLeftCommand(bettingSystem, data['chipSize']);
    }
}

export class BetRightCommand implements ISerializableBetCommand {
    private bettingSystem: IBettingSystem;
    private chipSize: number;

    constructor(bettingSystem: IBettingSystem, chipSize: number) {
        this.bettingSystem = bettingSystem;
        this.chipSize = chipSize;
    }

    execute(): void {
        for (let i = 4; i < 8; i++) {
            this.bettingSystem.addBet(i, this.chipSize);
        }
        console.log(`Placed bet of ${this.chipSize} on games 4-7`);
    }

    undo(): void {
        for (let i = 4; i < 8; i++) {
            this.bettingSystem.removeLastBet(i);
        }
        console.log(`Undid bet of ${this.chipSize} on games 4-7`);
    }

    serialize(): object {
        return {
            type: 'BetRightCommand',
            chipSize: this.chipSize
        };
    }

    static deserialize(bettingSystem: IBettingSystem, data: object): BetRightCommand {
        return new BetRightCommand(bettingSystem, data['chipSize']);
    }
}

export class DoubleBetCommand implements ISerializableBetCommand {
    private bettingSystem: IBettingSystem;
    private previousBets: number[][];

    constructor(bettingSystem: IBettingSystem) {
        this.bettingSystem = bettingSystem;
        this.previousBets = JSON.parse(JSON.stringify(bettingSystem.getBets()));
    }

    execute(): void {
        this.bettingSystem.doubleBets();
        console.log(`Doubled all bets`);
    }

    undo(): void {
        this.bettingSystem.setBets(this.previousBets);
        console.log(`Reverted doubling of all bets`);
    }

    serialize(): object {
        return {
            type: 'DoubleBetCommand'
        };
    }

    static deserialize(bettingSystem: IBettingSystem): DoubleBetCommand {
        return new DoubleBetCommand(bettingSystem);
    }
}
